import { execute } from "./_api";

const BASE_URL_CLIENTE_EVOLUCOES = "clienteEvolucoes";

export const atualizar = (data, params = {}) => {

    let rota = BASE_URL_CLIENTE_EVOLUCOES + "/atualizar";

    execute(rota,"PUT",data, params);
}

export const buscarEvolucaoAnterior = (data, params = {}) => {

    let rota = BASE_URL_CLIENTE_EVOLUCOES + "/buscarEvolucaoAnterior";

    execute(rota,"POST",data, params);
}

export const buscarPorClienteProcedimentoData = (data, params = {}) => {

    let rota = BASE_URL_CLIENTE_EVOLUCOES + "/buscarPorClienteProcedimentoData";

    execute(rota,"POST",data, params);
}

export const contarEvolucoesNaoPreenchidas = (data, params = {}) => {

    let rota = BASE_URL_CLIENTE_EVOLUCOES + "/contarEvolucoesNaoPreenchidas";

    execute(rota,"GET",data, params);
}

export const excluir = (data, params = {}) => {

    let rota = BASE_URL_CLIENTE_EVOLUCOES + "/excluir";

    execute(rota,"DELETE",data, params);
}

export const incluir = (data, params = {}) => {

    let rota = BASE_URL_CLIENTE_EVOLUCOES + "/incluir";

    execute(rota,"POST",data, params);
}

export const listarEvolucoesNaoPreenchidas = (data, params = {}) => {

    let rota = BASE_URL_CLIENTE_EVOLUCOES + "/listarEvolucoesNaoPreenchidas";

    execute(rota,"GET",data, params);
}

export const pesquisar = (data, params = {}) => {

    let rota = BASE_URL_CLIENTE_EVOLUCOES + "/pesquisar";

    execute(rota,"POST",data, params);
}

export const visualizar = (data, params = {}) => {

    let rota = BASE_URL_CLIENTE_EVOLUCOES + "/visualizar";

    execute(rota,"POST",data, params);
}
